import ProgressBarCIDContainer from './ProgressBarCIDContainer';

export default ProgressBarCIDContainer;
